<div class="margin-top" [formGroup]="searchForm">
  <div class="grid-x">
    <div class="cell large-12 bold text-align-center">
      Search for eDiscovery Requests:
    </div>
    <div class="cell large-3 text-align-right padding-right">
      Organization:<br />
      @if (organization != null) {
        <span class="bold">Selected Organization: {{organization.name}}</span>
      }
    </div>
    <div class="cell large-9 text-align-left padding-left">
      <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="availableOrgs$ | async" (selectionChanged)="orgSelectionChanged($event)" aria-label="Request Search"></ag-grid-angular>
    </div>
    <div class="cell large-3 text-align-right padding-right">
      Request ID:
    </div>
    <div class="cell large-9 text-align-left padding-left">
      <text-loader [run]="existingRequests == null" [tickType]="'.'" [text]="'Loading Requests'" [interval]="1500"></text-loader>
      @if (existingRequests?.length > 0) {
        <ng-select id="requestSelector" formControlName="requestSelector" class="limit-select" (ngModelChange)="validateSearchForm()" [items]="filteredRequests" bindLabel="displayText" bindValue="requestId"></ng-select>
      }
    </div>
    <div class="cell large-3 text-align-right padding-right">
      Status Type:
    </div>
    <div class="cell large-9 text-align-left padding-left">
      <select id="statusSelector" formControlName="statusType" class="limit-select" (change)="validateSearchForm()">
        <option [value]="searchTypes.All">All</option>
        <option [value]="searchTypes.Pending">Pending</option>
        <option [value]="searchTypes.Completed">Completed</option>
      </select>
    </div>
  </div>
</div>
